module.exports = __webpack_public_path__ + "img/SISGEOWEBSALA6.b15e826f.svg";